export const SPECS = {
  SendFullAddressOnExpressButtons: 'specs.stores.SendFullAddressOnExpressButtons',
  CheckoutFromSDKInExpressCheckoutButtons: 'specs.stores.CheckoutFromSDKInExpressCheckoutButtons',
  AddPoliciesToLineItems: 'specs.stores.AddPoliciesToLineItems',
  SupportMemberOnlyCheckout: 'specs.stores.SupportMemberOnlyCheckout'
};
//# sourceMappingURL=SPECS.js.map